import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import 'react-lazy-load-image-component/src/effects/blur.css';
import GameCard from "./GameCard";
import GameCardPlaceholder from "./GameCardPlaceholder";

function GameList(props) {
    const index_list = (window.innerWidth >= 768) ? (window.innerWidth >= 1024) ? 30 : 25 : 12;
    const [index, setIndex] = useState(index_list);
    const games = props.games;
    const isLoading = props.isLoading;

    useEffect(() => {
        setIndex(index_list);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [games])

    const hasLoadMore = () => {
        var total_count = games.length;
        if (index >= total_count) {
            return false;
        }
        return true;
    }

    const loadMore = () => {
        if (window.innerWidth < 768) {
            setIndex(index + index_list);
        } else if (window.innerWidth < 1024) {
            setIndex(index + index_list);
        } else {
            setIndex(index + index_list);
        }
    }

    const getIndexArray = () => {
        const rows = [];
        for (let i = 0; i < index_list; i++) {
            rows.push(i);
        }
        return rows;
    }

    return <>
        <div className="game-lists placeholder-glow">
            {isLoading ? <>
                {getIndexArray().map((v, i) => {
                    return <GameCardPlaceholder key={i} />;
                })}
            </> : <>
                {games ? games.filter((e, i) => {
                    return i < index;
                }).map((element, i) => {
                    return <GameCard data={props.data} key={i} element={element} index={i} isShow={index > i} />
                }) : <></>}
            </>}
        </div>

        {hasLoadMore() ?
            <div className="mt-4 mb-2 mx-auto text-center">
                <Button onClick={loadMore}>{t('gamelist.load_more')}</Button>
            </div>
            : <> </>}
    </>;
}

export default GameList;
